module.exports = __webpack_public_path__ + "static/media/lambo_wall.96f55065.jpg";